/* eslint-disable camelcase, no-undef, no-underscore-dangle */
/**
 * ESlint is disabled in this file
 * Reference: https://webpack.js.org/guides/public-path/#on-the-fly
 */

__webpack_public_path__ = '/';
